/**
 * Triage sessions (the per-project router and discuss item sessions, run ids `triage-…`) are
 * Viko's own plumbing: they are reachable from their bark (*Open triage conversation*), not
 * listed in Now next to the work runs (docs/ux/project-tab-spec.md §2.1).
 */
export const TRIAGE_RUN_PREFIX = 'triage-'

export function isTriageRun(r: { runId: string }): boolean {
  return r.runId.startsWith(TRIAGE_RUN_PREFIX)
}

export function withoutTriageRuns<T extends { runId: string }>(runs: readonly T[]): T[] {
  return runs.filter((r) => !isTriageRun(r))
}
